export enum BillingServiceProvider {
    STRIPE = 'stripe',
    ADPRUN = 'adprun',
}
